import React from "react";
import { Link } from "react-router-dom";
export default function ElementListItem(props) {
  const clickHandler = (e) => {
    if (props.onElementPick) {
      e.preventDefault();
    }
    if (props.onElementCheck) {
      e.preventDefault();
      props.onElementCheck(props);
    }
  };

  const dblClickHandler = (e) => {
    if (props.onElementPick) {
      e.preventDefault();
      props.onElementPick(props);
    }
  };

  const treePaddingMuliplier = props.treePaddingMuliplier || 0;
  return (
    <>
      <Link
        onClick={(e) => clickHandler(e)}
        onDoubleClick={(e) => dblClickHandler(e)}
        to={`/element/${props.shipId}/${props.specId}/${props.id}`}
      >
        <div
          className={`row py-4 px-2 border-bottom text-dark bg-hover-light align-items-center   ${
            props.highlightItem === String(props.id) ? "bg-light" : ""
          }`}
        >
          {props.onElementCheck && (
            <div className="btn btn-sm btn-icon">
              <i
                className={`fa ${
                  props.checkedElements.includes(props.id)
                    ? "fa-check-square-o text-primary"
                    : "fa-square-o"
                }`}
              ></i>
            </div>
          )}
          <div className={`col m-lg-0 my-3`}>
            <div className={`pl-${props.level * treePaddingMuliplier}`}>
              <div>
                {props.critical && (
                  <i
                    title="Критическое оборудование"
                    className="fa fa-exclamation-triangle text-danger mr-2"
                  ></i>
                )}
                {props.label}
              </div>
              <div>
                <span className="text-dark-50 small">{props.modelname}</span>
                {props.count > 1 && (
                  <span className="text-dark-75 small ml-2">
                    {props.count} шт.
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>
      </Link>
    </>
  );
}
